/*
 *
 * ErrorBoundary
 *
 * this component make react errors more readable
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error, info) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      info: info,
    });
  }

  render() {
    const { error, info } = this.state;
    if (info) {
      return (
        <div className="bigbody">
          <div className="errorbody">
            <h2>Something went wrong.</h2>
            <br />
            {error && <span>Here&apos;s the error: {error.toString()}</span>}
            <details className="detailsbutton">
              {info ? info.componentStack : <h3>Sorry, no more details</h3>}
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element,
};

ErrorBoundary.defaultProps = {
  children: React.createElement('div'),
};

export default ErrorBoundary;
